import { FC, useCallback, useEffect } from 'react';
import { Button, Upload } from 'antd';
import { UploadRequestOption } from 'rc-upload/es/interface';
import {
  ApiError,
  InputDataUploadInfoType,
  useMutateInputDataUpload,
} from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './InputDataUpload.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('input-data-upload');
addTranslations(translations);

export interface InputDataUploadProps {
  onUpload?: (response: InputDataUploadInfoType) => void;
  onUploadErrors?: (errors: ApiError[]) => void;
  onPendingChange?: (pending: boolean) => void;
}

export const InputDataUpload: FC<InputDataUploadProps> = (props) => {
  const { onUpload, onUploadErrors, onPendingChange } = props;
  const { t } = useTranslation();
  const { mutate, isPending } = useMutateInputDataUpload();

  useEffect(() => {
    onPendingChange?.(isPending);
  }, [isPending, onPendingChange]);

  const handleUpload = useCallback(
    (options: UploadRequestOption) => {
      const { file } = options;
      mutate(
        { file },
        {
          onSuccess: onUpload,
          onError: (error) =>
            onUploadErrors?.(error.response?.data.errors ?? []),
        },
      );
    },
    [mutate, onUpload, onUploadErrors],
  );

  return (
    <Upload customRequest={handleUpload} showUploadList={false}>
      <Button id="upload-input-data" loading={isPending} disabled={isPending}>
        {t('button.uploadInputData')}
      </Button>
    </Upload>
  );
};
